import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAgents = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.636 11.571c1.51 0 2.719-1.244 2.719-2.785 0-1.542-1.21-2.786-2.719-2.786S12.91 7.244 12.91 8.786c0 1.541 1.218 2.785 2.727 2.785zm-7.272 0c1.509 0 2.718-1.244 2.718-2.785C11.082 7.244 9.872 6 8.364 6c-1.51 0-2.728 1.244-2.728 2.786 0 1.541 1.219 2.785 2.728 2.785zm0 1.858C6.245 13.429 2 14.515 2 16.679V19h12.727v-2.321c0-2.164-4.245-3.25-6.363-3.25zm7.272 0c-.263 0-.563.018-.881.046 1.054.78 1.79 1.83 1.79 3.204V19H22v-2.321c0-2.164-4.245-3.25-6.364-3.25z",
			fillRule: "nonzero"
		})
	})
});
export default SvgAgents;
